var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgFormListNoContentStubc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 188,
  height: 158,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8BBC06",
  fillRule: "evenodd",
  d: "M22.332 54.328a5.55 5.55 0 1 1 0-11.098 5.55 5.55 0 0 1 0 11.098Zm16.654-3.039v-5.02l-3.957-1.005a13.089 13.089 0 0 0-1.233-2.976l2.087-3.51-3.55-3.55-3.51 2.087a13.088 13.088 0 0 0-2.975-1.233l-1.006-3.957h-5.02l-1.006 3.957c-1.05.29-2.048.707-2.976 1.233l-3.51-2.087-3.55 3.55 2.088 3.51a13.096 13.096 0 0 0-1.233 2.976l-3.957 1.005v5.02l3.957 1.006c.29 1.05.707 2.048 1.233 2.976l-2.087 3.51 3.55 3.55 3.51-2.088c.927.526 1.925.943 2.975 1.234l1.006 3.956h5.02l1.006-3.956c1.05-.29 2.048-.708 2.976-1.234l3.51 2.087 3.55-3.55-2.088-3.51a13.09 13.09 0 0 0 1.233-2.975l3.957-1.006Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#253368",
  fillRule: "evenodd",
  d: "M47.271 75.017a5.156 5.156 0 1 1 0-10.311 5.156 5.156 0 0 1 0 10.31Zm15.473-2.824V67.53l-3.676-.934a12.164 12.164 0 0 0-1.146-2.765l1.939-3.26-3.298-3.299-3.26 1.94a12.163 12.163 0 0 0-2.765-1.146l-.935-3.676H44.94l-.934 3.676c-.976.27-1.903.657-2.765 1.146l-3.26-1.94-3.298 3.298 1.939 3.261c-.49.862-.877 1.789-1.146 2.765l-3.676.934v4.664l3.676.934c.27.976.657 1.903 1.146 2.765l-1.94 3.26 3.299 3.299 3.26-1.94c.862.49 1.79.877 2.765 1.147l.934 3.676h4.664l.934-3.676c.976-.27 1.903-.657 2.765-1.146l3.26 1.939 3.299-3.298-1.94-3.26c.49-.863.877-1.79 1.147-2.766l3.676-.934Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M144.902 28.69v47.44"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#597EF7",
  d: "M153.703 33.87H44.27a4.444 4.444 0 0 0-4.444 4.443V88.72a4.444 4.444 0 0 0 4.444 4.444h109.433a4.444 4.444 0 0 0 4.444-4.444V38.313a4.444 4.444 0 0 0-4.444-4.444Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F54EB",
  d: "M138.885 48.682H88.708a1.48 1.48 0 0 0-1.481 1.48v2.963a1.48 1.48 0 0 0 1.48 1.482h50.178c.818 0 1.481-.663 1.481-1.482v-2.962a1.48 1.48 0 0 0-1.481-1.481Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#597EF7",
  d: "M115.555 72.383H88.708a1.48 1.48 0 0 0-1.481 1.481v2.963c0 .818.663 1.48 1.48 1.48h26.848a1.48 1.48 0 0 0 1.482-1.48v-2.963c0-.818-.663-1.481-1.482-1.481Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F54EB",
  d: "M138.885 60.533H88.708a1.48 1.48 0 0 0-1.481 1.481v2.963a1.48 1.48 0 0 0 1.48 1.481h50.178a1.48 1.48 0 0 0 1.481-1.481v-2.963a1.48 1.48 0 0 0-1.481-1.48ZM67.97 48.682H50.195a2.963 2.963 0 0 0-2.963 2.962V69.42a2.962 2.962 0 0 0 2.963 2.963H67.97a2.962 2.962 0 0 0 2.962-2.963V51.644a2.962 2.962 0 0 0-2.962-2.962Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M78.432 48.682v38.575"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#E4EBF7",
  d: "M134.447 70.02H25.014a4.444 4.444 0 0 0-4.444 4.443v50.407a4.444 4.444 0 0 0 4.444 4.444h109.433a4.444 4.444 0 0 0 4.444-4.444V74.463a4.444 4.444 0 0 0-4.444-4.444Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#597EF7",
  d: "M119.629 84.832H69.452a1.48 1.48 0 0 0-1.481 1.481v2.963a1.48 1.48 0 0 0 1.48 1.481h50.178c.818 0 1.482-.663 1.482-1.481v-2.963c0-.818-.664-1.481-1.482-1.481ZM96.3 108.533H69.452a1.48 1.48 0 0 0-1.481 1.481v2.963a1.48 1.48 0 0 0 1.48 1.481H96.3a1.48 1.48 0 0 0 1.48-1.481v-2.963a1.48 1.48 0 0 0-1.48-1.481Zm23.329-11.851H69.452a1.48 1.48 0 0 0-1.481 1.48v2.963c0 .818.663 1.482 1.48 1.482h50.178c.818 0 1.482-.664 1.482-1.482v-2.962c0-.818-.664-1.481-1.482-1.481Zm-70.915-11.85H30.94a2.962 2.962 0 0 0-2.962 2.963v17.775a2.962 2.962 0 0 0 2.962 2.962h17.775a2.962 2.962 0 0 0 2.963-2.962V87.795a2.963 2.963 0 0 0-2.963-2.963Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M59.176 84.832v38.575"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A46",
  fillRule: "evenodd",
  d: "m147.271 138.847 20.946-36.393h8.952l-20.622 36.393h-9.276Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A46",
  d: "M148.493 114.856a6.476 6.476 0 1 0 0-12.952 6.476 6.476 0 0 0 0 12.952Zm25.178 24.039a6.475 6.475 0 1 0 0-12.952 6.477 6.477 0 0 0 0 12.952Z"
})));
const Memo = /*#__PURE__*/memo(SvgFormListNoContentStubc);
export default Memo;